import React from 'react';
import { Spin, Space } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export default function GlobalLoading() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <Space size="middle">
        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
        <span>加载中...</span>
      </Space>
    </div>
  );
}